import { ChangePercentage, CountryCell, TrafficShare, IndexCell } from "app/components/React/Table/cells";
import { DefaultCellRightAlign } from "app/components/React/Table/cells/DefaultCellRightAlign";
import { PercentageCellRightAlign } from "app/components/React/Table/cells/PercentageCell";
import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";

const IndustryAnalysisGeoTableColumnsConfig = [
    {
        fixed: true,
        cellComponent: RowSelectionConsumer,
        disableHeaderCellHover: true,
        sortable: false,
        width: 33,
        headerComponent: DefaultCellHeader,
        visible: true,
    },
    {
        fixed: true,
        cellComponent: IndexCell,
        headerComponent: DefaultCellHeader,
        disableHeaderCellHover: true,
        sortable: false,
        width: 65,
        visible: true,
    },
    {
        fixed: true,
        field: "Country",
        get displayName() {
            return translate("industry.analysis.geo.table.column.country");
        },
        type: "string",
        format: "None",
        sortable: true,
        isSorted: false,
        cellComponent: CountryCell,
        headerComponent: DefaultCellHeader,
        sortDirection: "desc",
        totalCount: true,
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.country");
        },
        width: 300,
        showTotalCount: false,
        visible: true,
        ppt: {
            // override the table column format when rendered in ppt
            overrideFormat: "Country",
        },
    },
    {
        field: "TrafficShare",
        get displayName() {
            return translate("industry.analysis.geo.table.column.traffic.share");
        },
        type: "double",
        sortable: true,
        isSorted: false,
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.traffic.share");
        },
        width: 130,
        visible: true,
    },
    {
        field: "Visits",
        get displayName() {
            return translate("industry.analysis.geo.table.column.visits");
        },
        type: "double",
        format: "minVisitsAbbr",
        sortable: true,
        isSorted: false,
        cellComponent: DefaultCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.visits");
        },
        width: 130,
        visible: true,
    },
    {
        field: "Growth",
        get displayName() {
            return translate("industry.analysis.geo.table.column.growth");
        },
        type: "double",
        format: "abbrNumberSupportNegative:2",
        sortable: true,
        isSorted: false,
        cellComponent: DefaultCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.growth");
        },
        width: 130,
        visible: true,
    },
    {
        field: "GrowthPercentage",
        get displayName() {
            return translate("industry.analysis.geo.table.column.growth.percentage");
        },
        type: "double",
        format: "percentagesign:2",
        sortable: true,
        isSorted: false,
        cellComponent: ChangePercentage,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.growth.percentage");
        },
        width: 130,
        visible: true,
    },
    {
        field: "TimePerVisit",
        get displayName() {
            return translate("industry.analysis.geo.table.column.time.per.visit");
        },
        type: "double",
        format: "time",
        sortable: true,
        isSorted: false,
        cellComponent: DefaultCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.time.per.visit");
        },
        width: 130,
        visible: true,
    },
    {
        field: "PagesPerVisit",
        get displayName() {
            return translate("industry.analysis.geo.table.column.pages.per.visit");
        },
        type: "double",
        format: "number:2",
        sortable: true,
        isSorted: false,
        cellComponent: DefaultCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.pages.per.visit");
        },
        width: 130,
        visible: true,
    },
    {
        field: "BounceRate",
        get displayName() {
            return translate("industry.analysis.geo.table.column.bounce.rate");
        },
        type: "double",
        format: "percentage:2",
        sortable: true,
        isSorted: false,
        cellComponent: PercentageCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        get tooltip() {
            return translate("industry.analysis.geo.table.tooltip.bounce.rate");
        },
        width: 130,
        visible: true,
    },
];

export const industryAnalysisGeoTableColumnsConfigGen = (sortbyField: string, sortDirection: string) => {
    return IndustryAnalysisGeoTableColumnsConfig.map((col, idx) => {
        if (!col.sortable) {
            return col;
        }
        return {
            ...col,
            isSorted: col.field === sortbyField,
            sortDirection: col.field === sortbyField ? sortDirection : col.sortDirection,
        };
    });
};
